export const CONVERSATION_PRIORITY = {
  NONE: 'none',
  LOW: 'low',
  LOWEST: 'lowest',
  MEDIUM: 'medium',
  HIGH: 'high',
  HIGHEST: 'highest',
};

export const CONVERSATION_PRIORITY_MAP = {
  [CONVERSATION_PRIORITY.NONE]: { flagState: 'none', displayName: 'None' },
  [CONVERSATION_PRIORITY.LOW]: { flagState: 'low', displayName: 'Low' },
  [CONVERSATION_PRIORITY.LOWEST]: {
    flagState: 'low',
    displayName: 'Lowest',
  },
  [CONVERSATION_PRIORITY.MEDIUM]: {
    flagState: 'normal',
    displayName: 'Medium',
  },
  [CONVERSATION_PRIORITY.HIGH]: { flagState: 'high', displayName: 'High' },
  [CONVERSATION_PRIORITY.HIGHEST]: {
    flagState: 'urgent',
    displayName: 'Highest',
  },
};

export const CONVERSATION_VENDORS = {
  zendesk: {
    value: 'zendesk',
    displayName: 'Zendesk',
  },
  freshdesk: {
    value: 'freshdesk',
    displayName: 'Freshdesk',
  },
  intercom: {
    value: 'intercom',
    displayName: 'Intercom',
  },
  jira: {
    value: 'jira',
    displayName: 'Jira',
  },
  hubspot: {
    value: 'hubspot',
    displayName: 'Hubspot',
  },
  salesforce: {
    value: 'salesforce',
    displayName: 'Salesforce',
  },
};

export const CONVERSATION_TYPE = {
  WEB: 'web',
  API: 'api',
  EMAIL: 'email',
  CHAT: 'chat',
  PHONE: 'phone',
  PORTAL: 'portal',
  ACTIVITY: 'activity',
};

export const MAX_CONVERSATION_LIMIT_ACTIVITYFEED = 100;
